import React, { useState, useRef, useMemo, useEffect } from 'react'
import { Model } from 'survey-core'
import { Survey } from 'survey-react-ui'
// import 'survey-core/defaultV2.min.css'

import { useConvertSurvey } from '../hooks/useConvertSurvey'
import { useSubmitAnswers } from '../hooks/useSubmitAnswers'
import 'survey-core/i18n/traditional-chinese'

const Agree = ({
  setAc,
  setTk,
  ac,
  tk,
  pid,
  setIsLoading,
  setCompletionMessage,
}) => {
  const [myAgreeJson, setMyAgreeJson] = useState(null)
  // 需要登入嗎
  const requiresLogin = {
    login: false,
    title: '員工編號（邁達特：MA、啟迪：GI、聚上雲：EP、逐鹿：GU）',
    placeholder: 'MA00000',
    alert: '員工編號有誤，請重新登入，謝謝',
  }
  const [imagesReadingTime, setImagesReadingTime] = useState(0)
  const canShowPrevButtonPages = null
  const choicesOrderRef = useRef({})
  const choiceIndexMapRef = useRef({})
  const bringOptionsMapRef = useRef({})
  // 防止閃閃
  useEffect(() => {
    const timeout = setTimeout(() => {
      const isMobile = window.innerWidth <= 576
      if (!isMobile) return

      const observer = new MutationObserver((mutationsList) => {
        for (let mutation of mutationsList) {
          if (mutation.type === 'childList') {
            const rootEl = document.querySelector('.sd-root-modern')
            if (
              rootEl &&
              !rootEl.classList.contains('sd-root-modern--mobile')
            ) {
              rootEl.classList.add('sd-root-modern--mobile')
              console.log('✅ 強制加上 mobile class 避免抖動')
            }
          }
        }
      })

      observer.observe(document.getElementById('root'), {
        childList: true,
        subtree: true,
      })

      // 清除
      return () => observer.disconnect()
    }, 100) // 100ms 後再判斷

    return () => clearTimeout(timeout)
  }, [])
  // 圖片閱讀時間(秒)
  // useEffect(() => {
  //   setImagesReadingTime(30)
  // }, [])
  const completedHtml = `<h3>問卷正在提交中，請稍候。</h3><h3>請在成功頁面顯示後再離開。</h3><h4>如有填卷相關問題請洽：</h4> <a href='https://lin.ee/HWETcqy'>https://lin.ee/HWETcqy</a><h4 style='margin-top:50px'>填寫其他問卷：</h4> <a href=${window.location.origin}>${window.location.origin}</a>`

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const agreeSurvey = new Model(myAgreeJson)

  // 問卷編號
  // const pid = pid
  // 跳題 小心複選題要用陣列

  // const visibleIfConditionsInit = {
  //   q6: '{q5} = 0 or {q5} = 1 or {q5} = 2 or {q5} = 3',
  //   q7: '{q6} = ["none"]',
  //   q36: `{q35} <> ['none']`,
  // }

  const visibleIfConditionsInit = {
    q9: '{q8} anyof [1, 2]',
    q12: '{q10} anyof [1]',
    q13: '{q10} anyof [2]',
    q14: '{q10} anyof [3]',
    q15: '{q10} anyof [0]',
    q16: '{q10} anyof [4, 5, 6, 7, 8]',
    q17: '{q10} anyof [1]',
    q18: '{q10} anyof [2]',
    q19: '{q10} anyof [3]',
    q20: '{q10} anyof [0]',
    q21: '{q10} anyof [4, 5, 6, 7, 8]',
    q23: '{q22} anyof [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15]',
    q24: '{q23} anyof [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15]',
    // 當時想去吃的原因
    // q25: '{q23} anyof [0]',
    // q26: '{q23} anyof [1]',
    // q27: '{q23} anyof [2]',
    // q28: '{q23} anyof [3]',
    // q29: '{q23} anyof [4]',
    // q30: '{q23} anyof [7]',
    // q31: '{q23} anyof [8]',
    // q32: '{q23} anyof [10]',
    // q33: '{q23} anyof [14]',
    // q34: '{q23} anyof [15]',
    // 回訪的原因
    // q35: '{q24} anyof [0]',
    // q36: '{q24} anyof [1]',
    // q37: '{q24} anyof [2]',
    // q38: '{q24} anyof [3]',
    // q39: '{q24} anyof [4]',
    // q40: '{q24} anyof [7]',
    // q41: '{q24} anyof [8]',
    // q42: '{q24} anyof [10]',
    // q43: '{q24} anyof [14]',
    // q44: '{q24} anyof [15]',
    // 去的情境
    // q45: '{q23} anyof [0]',
    // q46: '{q23} anyof [1]',
    // q47: '{q23} anyof [2]',
    // q48: '{q23} anyof [3]',
    // q49: '{q23} anyof [4]',
    // q50: '{q23} anyof [7]',
    // q51: '{q23} anyof [8]',
    // q52: '{q23} anyof [10]',
    // q53: '{q23} anyof [14]',
    // q54: '{q23} anyof [15]',
    // 有選烤鴨的才出現
    q56: '({q10} anyof [0]) and ({q55} anyof [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19])',
    q57: '({q10} anyof [0]) and ({q56} anyof [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19])',
    // 當時想去吃烤鴨的原因
    // q58: '({q10} anyof [0]) and ({q56} anyof [0])',
    // q59: '({q10} anyof [0]) and ({q56} anyof [1])',
    // q60: '({q10} anyof [0]) and ({q56} anyof [2])',
    // q61: '({q10} anyof [0]) and ({q56} anyof [3])',
    // q62: '({q10} anyof [0]) and ({q56} anyof [4])',
    // q63: '({q10} anyof [0]) and ({q56} anyof [5])',
    // q64: '({q10} anyof [0]) and ({q56} anyof [6])',
    // q65: '({q10} anyof [0]) and ({q56} anyof [7])',
    // q66: '({q10} anyof [0]) and ({q56} anyof [8])',
    // q67: '({q10} anyof [0]) and ({q56} anyof [9])',
    // q68: '({q10} anyof [0]) and ({q56} anyof [10])',
    // q69: '({q10} anyof [0]) and ({q56} anyof [11])',
    // q70: '({q10} anyof [0]) and ({q56} anyof [12])',
    // q71: '({q10} anyof [0]) and ({q56} anyof [13])',
    // q72: '({q10} anyof [0]) and ({q56} anyof [14])',
    // q73: '({q10} anyof [0]) and ({q56} anyof [15])',
    // q74: '({q10} anyof [0]) and ({q56} anyof [16])',
    // q75: '({q10} anyof [0]) and ({q56} anyof [17])',
    // q76: '({q10} anyof [0]) and ({q56} anyof [18])',
    // q77: '({q10} anyof [0]) and ({q56} anyof [19])',
    // // 回訪烤鴨的原因
    // q78: '({q10} anyof [0]) and ({q57} anyof [0])',
    // q79: '({q10} anyof [0]) and ({q57} anyof [1])',
    // q80: '({q10} anyof [0]) and ({q57} anyof [2])',
    // q81: '({q10} anyof [0]) and ({q57} anyof [3])',
    // q82: '({q10} anyof [0]) and ({q57} anyof [4])',
    // q83: '({q10} anyof [0]) and ({q57} anyof [5])',
    // q84: '({q10} anyof [0]) and ({q57} anyof [6])',
    // q85: '({q10} anyof [0]) and ({q57} anyof [7])',
    // q86: '({q10} anyof [0]) and ({q57} anyof [8])',
    // q87: '({q10} anyof [0]) and ({q57} anyof [9])',
    // q88: '({q10} anyof [0]) and ({q57} anyof [10])',
    // q89: '({q10} anyof [0]) and ({q57} anyof [11])',
    // q90: '({q10} anyof [0]) and ({q57} anyof [12])',
    // q91: '({q10} anyof [0]) and ({q57} anyof [13])',
    // q92: '({q10} anyof [0]) and ({q57} anyof [14])',
    // q93: '({q10} anyof [0]) and ({q57} anyof [15])',
    // q94: '({q10} anyof [0]) and ({q57} anyof [16])',
    // q95: '({q10} anyof [0]) and ({q57} anyof [17])',
    // q96: '({q10} anyof [0]) and ({q57} anyof [18])',
    // q97: '({q10} anyof [0]) and ({q57} anyof [19])',
    // // 享鴨
    // q98: '({q10} anyof [0]) and ({q56} anyof [0])',
    q99: '({q98} = 0 or {q98} = 1 or {q98} = 2)',
    // // 去烤鴨的情境
    // q100: '({q10} anyof [0]) and ({q56} anyof [0])',
    // q101: '({q10} anyof [0]) and ({q56} anyof [1])',
    // q102: '({q10} anyof [0]) and ({q56} anyof [2])',
    // q103: '({q10} anyof [0]) and ({q56} anyof [3])',
    // q104: '({q10} anyof [0]) and ({q56} anyof [4])',
    // q105: '({q10} anyof [0]) and ({q56} anyof [5])',
    // q106: '({q10} anyof [0]) and ({q56} anyof [6])',
    // q107: '({q10} anyof [0]) and ({q56} anyof [7])',
    // q108: '({q10} anyof [0]) and ({q56} anyof [8])',
    // q109: '({q10} anyof [0]) and ({q56} anyof [9])',
    // q110: '({q10} anyof [0]) and ({q56} anyof [10])',
    // q111: '({q10} anyof [0]) and ({q56} anyof [11])',
    // q112: '({q10} anyof [0]) and ({q56} anyof [12])',
    // q113: '({q10} anyof [0]) and ({q56} anyof [13])',
    // q114: '({q10} anyof [0]) and ({q56} anyof [14])',
    // q115: '({q10} anyof [0]) and ({q56} anyof [15])',
    // // 比較貴的烤鴨
    // q116: '({q10} anyof [0]) and ({q56} anyof [16, 17, 18, 19])',
    // 假隨機
    q117: '({q10} anyof [0]) and ({q2} = 0 or {q2} = 5)',
    q118: '({q10} anyof [0]) and ({q2} = 1 or {q2} = 4)',
    q119: '({q10} anyof [0]) and ({q2} = 2 or {q2} = 3)',
    // C1-1
    q120: '({q10} anyof [1])',
    q121: '({q10} anyof [4, 5, 6, 7, 8])',
    // q122: '({q56} anyof [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15])',
    // q123: '({q56} anyof [16, 17, 18, 19])',

    q124: '({q10} anyof [1])',
    q125: '({q10} anyof [4, 5, 6, 7, 8])',
    // q126: '({q56} anyof [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15])',
    // q127: '({q56} anyof [16, 17, 18, 19])',
    // 矩陣接題 情境一
    q131: '{q130.0} = 3 or {q130.0} = 4',
    q132: '{q130.1} = 3 or {q130.1} = 4',
    q133: '{q130.2} = 3 or {q130.2} = 4',
    q134: '{q130.3} = 3 or {q130.3} = 4',
    // 矩陣接題 情境二
    q137: '{q136.0} = 3 or {q136.0} = 4',
    q138: '{q136.1} = 3 or {q136.1} = 4',
    q139: '{q136.2} = 3 or {q136.2} = 4',
    q140: '{q136.3} = 3 or {q136.3} = 4',
    // 抽獎
    q146: '{q145} = 0',
    q147: '{q145} = 0',
  }
  // const visibleIfConditionsInit = null
  // const pageVisibleIfConditionsInit = null

  // 非必填(從 0 計算)
  const notRequired = [6, 11, 128, 129, 135]
  // const notRequired = null

  const mappedRateChoice = null
  // const pageBreakQuestions = ['q6', 'q11', 'q15']
  const pageBreakQuestions = null

  const triggersConditionsInit = [
    {
      type: 'complete',
      expression: `({q0} = 2) or ({q1} = 0 or {q1} = 1 or {q1} = 2 or {q1} = 7) or ({q2} = 6) or ({q3} = 0 or {q3} = 1) or ({q4} = 2) or ({q5} notcontains 0) or ({q7} = 3) or ({q8} notcontains 1 and {q8} notcontains 2) or ({q10} = ['other'])`,
    },
  ]
  // const triggersConditionsInit = null
  // const pageVisibleIfConditionsInit = null

  // 帶入選項
  // 帶入帶出參考
  // 帶出: 帶入
  const questionMappings = {
    q8: 'q9',
    q22: 'q23',
    q23: 'q24',
    q55: 'q56',
    q56: 'q57',
  }

  const convertedSurvey = useConvertSurvey({
    survey: agreeSurvey,
    pid,
    setAc,
    setTk,
    ac,
    tk,
    setMyAgreeJson,
    imagesReadingTime,
    setImagesReadingTime,
    setIsLoading,
    completedHtml,
    visibleIfConditionsInit,
    notRequired,
    mappedRateChoice,
    pageBreakQuestions,
    requiresLogin,
    triggersConditionsInit,
    bringOptionsMapRef,
    questionMappings, // 帶入選項
  })

  // const newSurvey = new Model(convertedSurvey)

  const surveyModel = useMemo(() => {
    if (!convertedSurvey) return null
    return new Model(convertedSurvey)
  }, [convertedSurvey])

  useEffect(() => {
    if (!surveyModel) return

    surveyModel.onAfterRenderQuestion.add((_, options) => {
      const labels = options.htmlElement.querySelectorAll('.sv-string-viewer')

      labels.forEach((label) => {
        const text = label.innerText?.trim()
        if (text.startsWith('==== 【')) {
          const item = label.closest('.sv-item, .sd-item')
          if (item) {
            item.style.pointerEvents = 'none'
            item.style.backgroundColor = '#f5f5f5'
            item.style.fontWeight = 'bold'
            item.style.padding = '8px 12px'
            item.style.borderRadius = '4px'

            // ✅ 額外強制隱藏外框裝飾
            const decorator = item.querySelector(
              '.sv-item__decorator, .sd-item__decorator, .sv-checkbox__decorator, .sv-radio__decorator'
            )
            if (decorator) {
              decorator.style.display = 'none'
            }

            // ✅ 也強制隱藏 input 本體（多半已隱藏，但保險起見）
            const input = item.querySelector(
              'input[type="checkbox"], input[type="radio"]'
            )
            if (input) {
              input.style.display = 'none'
            }
          }

          // cursor
          label.style.cursor = 'default'
        }
      })
    })
  }, [surveyModel])

  // useEffect(() => {
  //   console.log('convertedSurvey', convertedSurvey)
  // }, [convertedSurvey])

  const endMessage = `謝謝您，該條件配額已額滿。期待未來有機會再邀請您參與！歡迎您分享本問卷連結給其他親朋好友，或加入我們的<a href='https://lin.ee/HWETcqy'>LINE@</a>，隨時得到最新填問卷獲好禮的消息。<p>請按「完成」前往下載 EZChoice 或填寫更多問卷</p>`

  function helpFunction(survey, options) {
    // console.log('survey.getValue(q42)', survey.getValue('q7'))
    // 參考 P231113152849 或 P231101165555 或 P231206105643(政大帶入選項)

    // 處理帶入選項的 none 邏輯（通用）
    const handleNoneForBringingOptions = (questionName, question, vals) => {
      if (vals.length === 1 && vals[0] === 'none' && question.showNoneItem) {
        console.log(`✅ ${questionName} 檢測到選擇 none`)

        const existingNoneIndex = question.choices.findIndex(
          (c) => c.value === 'none' || c.text === question.noneText
        )

        let noneIndex
        if (existingNoneIndex === -1) {
          // 不添加實際選項，只計算應該在的位置
          noneIndex = question.choices.length
        } else {
          noneIndex = existingNoneIndex
        }

        // 動態找到來源問題
        const sourceQuestionName = Object.keys(bringOptionsMapRef.current).find(
          (sourceKey) => bringOptionsMapRef.current[sourceKey] === questionName
        )

        if (sourceQuestionName) {
          const sourceNoneIndex =
            choiceIndexMapRef.current[sourceQuestionName]?.none
          const sourceQuestionIndex = Number(
            sourceQuestionName.replace('q', '')
          )

          // 建立 choiceIndexMapRef
          choiceIndexMapRef.current[questionName] =
            choiceIndexMapRef.current[questionName] || {}

          choiceIndexMapRef.current[questionName][noneIndex] = {
            index: noneIndex,
            title: question.noneText,
            origin_op: sourceNoneIndex,
            origin_qi: sourceQuestionIndex,
          }

          console.log(
            `✅ 在 ${questionName} 建立 none 的 choiceIndexMapRef:`,
            choiceIndexMapRef.current[questionName]
          )
        }

        return [noneIndex] // 返回轉換後的 vals
      }
      return vals // 沒有變更就返回原值
    }

    if (options.name === 'q23') {
      const selected = options.value || []
      const selectedTexts = selected.map((v) => {
        const found = options.question.visibleChoices.find((c) => c.value === v)
        return found?.text
      })

      const mapping = {
        q25: '開飯川',
        q26: '時時香',
        q27: '1010湘',
        q28: '真珠',
        q29: '欣葉小聚',
        q30: '莆田',
        q31: '丰禾',
        q32: '富錦樹台菜香檳',
        q33: '鼎泰豐',
        q34: '十二月粥品茶飲私房菜',

        q45: '開飯川',
        q46: '時時香',
        q47: '1010湘',
        q48: '真珠',
        q49: '欣葉小聚',
        q50: '莆田',
        q51: '丰禾',
        q52: '富錦樹台菜香檳',
        q53: '鼎泰豐',
        q54: '十二月粥品茶飲私房菜',
      }

      Object.entries(mapping).forEach(([qid, text]) => {
        const q = survey.getQuestionByName(qid)
        if (q) q.visible = selectedTexts.includes(text)
      })

      // ✅ 使用通用函數處理 none
      const question = options.question
      let vals = Array.isArray(options.value) ? options.value : [options.value]
      vals = handleNoneForBringingOptions('q23', question, vals)
    }

    if (options.name === 'q24') {
      const selected = options.value || []
      const selectedTexts = selected.map((v) => {
        const found = options.question.visibleChoices.find((c) => c.value === v)
        return found?.text
      })

      const mapping = {
        q35: '開飯川',
        q36: '時時香',
        q37: '1010湘',
        q38: '真珠',
        q39: '欣葉小聚',
        q40: '莆田',
        q41: '丰禾',
        q42: '富錦樹台菜香檳',
        q43: '鼎泰豐',
        q44: '十二月粥品茶飲私房菜',
      }

      Object.entries(mapping).forEach(([qid, text]) => {
        const q = survey.getQuestionByName(qid)
        if (q) q.visible = selectedTexts.includes(text)
      })

      // ✅ 使用通用函數處理 none
      const question = options.question
      let vals = Array.isArray(options.value) ? options.value : [options.value]
      vals = handleNoneForBringingOptions('q24', question, vals)
    }

    if (options.name === 'q56') {
      const selected = options.value || []
      const selectedTexts = selected.map((v) => {
        const found = options.question.visibleChoices.find((c) => c.value === v)
        return found?.text
      })

      const mappingQ58to77 = {
        q58: '享鴨',
        q59: '鴨點棧',
        q60: '鴨寮街',
        q61: '上菜片皮鴨',
        q62: 'LA時尚(烤鴨)川菜',
        q63: '滿玥軒',
        q64: '九華樓',
        q65: '陶然亭',
        q66: '龍都',
        q67: '宋廚',
        q68: '鴨片館',
        q69: '全鴨坊',
        q70: '柴火火焰烤鴨',
        q71: '金悅軒',
        q72: '印月',
        q73: '賀鴨郎',
        q74: '頤宮',
        q75: '蘭城晶英紅樓中餐廳',
        q76: '湛露',
        q77: '晶華軒',
      }

      const mappingQ98to99 = {
        q98: '享鴨',
        // q99: '享鴨',
      }

      const mappingQ100to115 = {
        q100: '享鴨',
        q101: '鴨點棧',
        q102: '鴨寮街',
        q103: '上菜片皮鴨',
        q104: 'LA時尚(烤鴨)川菜',
        q105: '滿玥軒',
        q106: '九華樓',
        q107: '陶然亭',
        q108: '龍都',
        q109: '宋廚',
        q110: '鴨片館',
        q111: '全鴨坊',
        q112: '柴火火焰烤鴨',
        q113: '金悅軒',
        q114: '印月',
        q115: '賀鴨郎',
      }

      const expensiveSet = new Set([
        '頤宮',
        '蘭城晶英紅樓中餐廳',
        '湛露',
        '晶華軒',
      ])

      // 顯示 q58–q77（烤鴨系列）
      Object.entries(mappingQ58to77).forEach(([qid, text]) => {
        const q = survey.getQuestionByName(qid)
        if (q) q.visible = selectedTexts.includes(text)
      })

      // 顯示 q98, q99（享鴨）
      Object.entries(mappingQ98to99).forEach(([qid, text]) => {
        const q = survey.getQuestionByName(qid)
        if (q) q.visible = selectedTexts.includes(text)
      })

      // 顯示 q100–q115（吃情境）
      Object.entries(mappingQ100to115).forEach(([qid, text]) => {
        const q = survey.getQuestionByName(qid)
        if (q) q.visible = selectedTexts.includes(text)
      })

      // 顯示 q116（選到任一個昂貴品牌）
      const q116 = survey.getQuestionByName('q116')
      if (q116) {
        q116.visible = selectedTexts.some((text) => expensiveSet.has(text))
      }

      // C系列
      // 顯示 q122 / q126：只要有選到 0~15 的任一個
      const normalDuckSet = new Set([
        '享鴨',
        '鴨點棧',
        '鴨寮街',
        '上菜片皮鴨',
        'LA時尚(烤鴨)川菜',
        '滿玥軒',
        '九華樓',
        '陶然亭',
        '龍都',
        '宋廚',
        '鴨片館',
        '全鴨坊',
        '柴火火焰烤鴨',
        '金悅軒',
        '印月',
        '賀鴨郎',
      ])

      const showQ122 = selectedTexts.some((text) => normalDuckSet.has(text))
      const showQ126 = showQ122

      const q122 = survey.getQuestionByName('q122')
      if (q122) q122.visible = showQ122

      const q126 = survey.getQuestionByName('q126')
      if (q126) q126.visible = showQ126

      // 顯示 q123 / q127：只要有選到 16~19 的任一個
      const premiumDuckSet = new Set([
        '頤宮',
        '蘭城晶英紅樓中餐廳',
        '湛露',
        '晶華軒',
      ])

      const showQ123 = selectedTexts.some((text) => premiumDuckSet.has(text))
      const showQ127 = showQ123

      const q123 = survey.getQuestionByName('q123')
      if (q123) q123.visible = showQ123

      const q127 = survey.getQuestionByName('q127')
      if (q127) q127.visible = showQ127

      // ✅ 使用通用函數處理 none
      const question = options.question
      let vals = Array.isArray(options.value) ? options.value : [options.value]
      vals = handleNoneForBringingOptions('q56', question, vals)
    }

    if (options.name === 'q57') {
      const selected = options.value || []
      const selectedTexts = selected.map((v) => {
        const found = options.question.visibleChoices.find((c) => c.value === v)
        return found?.text
      })

      const mapping = {
        q78: '享鴨',
        q79: '鴨點棧',
        q80: '鴨寮街',
        q81: '上菜片皮鴨',
        q82: 'LA時尚(烤鴨)川菜',
        q83: '滿玥軒',
        q84: '九華樓',
        q85: '陶然亭',
        q86: '龍都',
        q87: '宋廚',
        q88: '鴨片館',
        q89: '全鴨坊',
        q90: '柴火火焰烤鴨',
        q91: '金悅軒',
        q92: '印月',
        q93: '賀鴨郎',
        q94: '頤宮',
        q95: '蘭城晶英紅樓中餐廳',
        q96: '湛露',
        q97: '晶華軒',
      }

      Object.entries(mapping).forEach(([qid, text]) => {
        const q = survey.getQuestionByName(qid)
        if (q) q.visible = selectedTexts.includes(text)
      })

      // ✅ 使用通用函數處理 none
      const question = options.question
      let vals = Array.isArray(options.value) ? options.value : [options.value]
      vals = handleNoneForBringingOptions('q57', question, vals)
    }
  }

  // 初始時強制隱藏
  useEffect(() => {
    if (!surveyModel) return
    const alwaysHidden = [
      'q25',
      'q26',
      'q27',
      'q28',
      'q29',
      'q30',
      'q31',
      'q32',
      'q33',
      'q34',
      'q35',
      'q36',
      'q37',
      'q38',
      'q39',
      'q40',
      'q41',
      'q42',
      'q43',
      'q44',
      'q45',
      'q46',
      'q47',
      'q48',
      'q49',
      'q50',
      'q51',
      'q52',
      'q53',
      'q54',
      // 烤鴨系列
      'q58',
      'q59',
      'q60',
      'q61',
      'q62',
      'q63',
      'q64',
      'q65',
      'q66',
      'q67',
      'q68',
      'q69',
      'q70',
      'q71',
      'q72',
      'q73',
      'q74',
      'q75',
      'q76',
      'q77',
      'q78',
      'q79',
      'q80',
      'q81',
      'q82',
      'q83',
      'q84',
      'q85',
      'q86',
      'q87',
      'q88',
      'q89',
      'q90',
      'q91',
      'q92',
      'q93',
      'q94',
      'q95',
      'q96',
      'q97',
      'q98',
      'q100',
      'q101',
      'q102',
      'q103',
      'q104',
      'q105',
      'q106',
      'q107',
      'q108',
      'q109',
      'q110',
      'q111',
      'q112',
      'q113',
      'q114',
      'q115',
      'q116',
      // C 系列
      'q122',
      'q123',
      'q126',
      'q127',
    ]
    alwaysHidden.forEach((qid) => {
      const q = surveyModel.getQuestionByName(qid)
      if (q) q.visible = false
    })
  }, [surveyModel])

  const endSurveyMsg = (survey) => {
    if (
      survey.getValue('q0') === 2 ||
      survey.getValue('q1') === 0 ||
      survey.getValue('q1') === 1 ||
      survey.getValue('q1') === 2 ||
      survey.getValue('q1') === 7 ||
      survey.getValue('q2') === 6 ||
      survey.getValue('q3') === 0 ||
      survey.getValue('q3') === 1 ||
      survey.getValue('q4') === 2 ||
      !survey.getValue('q5')?.includes(0) ||
      survey.getValue('q7') === 3 ||
      (!survey.getValue('q8')?.includes(1) &&
        !survey.getValue('q8')?.includes(2)) ||
      survey.getValue('q10')?.includes('other')
    ) {
      setCompletionMessage(endMessage)
    } else {
      setCompletionMessage(
        `<h4 style='text-align: center'>問卷已成功送出</h4><h4 style='text-align: center'>請按「完成」前往下載 EZChoice 或填寫更多問卷</h4>`
      )
    }
  }

  useEffect(() => {
    console.log('bringOptionsMapRef', bringOptionsMapRef)
  }, [bringOptionsMapRef])

  useSubmitAnswers({
    survey: surveyModel,
    pid,
    ac,
    tk,
    imagesReadingTime,
    setIsLoading,
    helpFunction,
    canShowPrevButtonPages,
    choicesOrderRef,
    choiceIndexMapRef,
    endSurveyMsg,
    bringOptionsMapRef,
  })

  return (
    <>
      {surveyModel ? (
        <Survey model={surveyModel} key={pid} />
      ) : myAgreeJson ? (
        <Survey model={agreeSurvey} />
      ) : (
        <></>
      )}
    </>
  )
}

export default Agree
